import React, { useState } from "react";
import { Alert, Button } from "@mui/material";
import { useAuth } from "../AuthContext";
import { resendVerification } from "../authApi";

export function EmailBanner() {
  const { isAuthenticated, isEmailVerified } = useAuth();
  const [resent, setResent] = useState(false);
  const [sending, setSending] = useState(false);

  if (!isAuthenticated || isEmailVerified) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerification();
      setResent(true);
    } catch {
      // Silently fail — the banner is already informative
    } finally {
      setSending(false);
    }
  };

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0 }}
      action={
        !resent ? (
          <Button
            color="inherit"
            size="small"
            onClick={handleResend}
            disabled={sending}
          >
            {sending ? "Sending..." : "Resend"}
          </Button>
        ) : undefined
      }
    >
      {resent
        ? "Verification email sent! Check your inbox."
        : "Please verify your email address to unlock all features."}
    </Alert>
  );
}
